import './UnderwritingSingleTenant.scss';
import Component from './UnderwritingSingleTenant.js';
export default Component;
